import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import DashboardNew from "@/pages/DashboardNew";
import CRM from "@/pages/CRM";
import Analytics from "@/pages/Analytics";
import Marketing from "@/pages/Marketing";
import SystemLogs from "@/pages/SystemLogs";
import ManageStaff from "@/pages/ManageStaff";
import PublicBooking from "@/pages/PublicBooking";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/book" element={<PublicBooking />} />
            <Route path="/login" element={<Login />} />
            
            {/* Protected Admin Routes */}
            <Route path="/" element={<Layout />}>
              <Route index element={<DashboardNew />} />
              <Route path="crm" element={<CRM />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="logs" element={<SystemLogs />} />
              <Route path="staff" element={<ManageStaff />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;